import { Image, type ImageStyle } from 'react-native'
import { useIsBenefitScreenPresentedAsModal } from '@/src/experiences/card-benefits/components/BenefitModal'
import type { ComponentProps } from 'react'

export function CardBenefitsComponentsHero(
  props: ComponentProps<typeof Image> & Pick<ImageStyle, 'backgroundColor'>,
) {
  const isBenefitScreenPresentedAsModal = useIsBenefitScreenPresentedAsModal()

  return (
    <Image
      resizeMode={props.backgroundColor ? 'contain' : 'cover'}
      {...props}
      style={[
        { height: 201, width: '100%', backgroundColor: props.backgroundColor },
        !isBenefitScreenPresentedAsModal && {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        },
        props.style,
      ]}
    />
  )
}
